// src/utils/artkivLabels.js

// VERSION FINAL FIX — includes medium (technique) translation

import { getArtTypeCanonicalKey } from "./artTypeTaxonomy";

const humanizeKey = (value) => {
  if (!value) return "—";
  return String(value)
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
};

export const ARTKIV_LABEL_PATHS = {
  typeOfArt: "artwork.typeOfArt",
  availability: "artwork.availability",
  condition: "artwork.condition",
  mediumCategory: "artworkEdit.detail",
  medium: "artwork.mediums", // NEW
};

export const getArtkivLabel = (type, key, t, fallback = "—") => {
  if (!key) return fallback;

  const basePath = ARTKIV_LABEL_PATHS[type];

  if (!basePath || typeof t !== "function") {
    return humanizeKey(key);
  }

  // --- MEDIUM (TECHNIQUE) ---
  if (type === "medium") {
    return t(`${basePath}.${key}`, {
      defaultValue: humanizeKey(key),
    });
  }

  // --- MEDIUM CATEGORY ---
  if (type === "mediumCategory") {
    const map = {
      painting: "mediumCategoryPainting",
      photography: "mediumCategoryPhotography",
      sculpture: "mediumCategorySculpture",
      prints: "mediumCategoryPrints",
      print: "mediumCategoryPrints",
      drawing: "mediumCategoryDrawing",
      work_on_paper: "mediumCategoryWorkOnPaper",
      mixed_media: "mediumCategoryMixedMedia",
      installation: "mediumCategoryInstallation",
      film_video: "mediumCategoryFilmVideo",
      digital: "mediumCategoryNft",
      nft: "mediumCategoryNft",
      ceramics: "mediumCategoryCeramics",
      textile: "mediumCategoryTextile",
      design: "mediumCategoryDesign",
      other: "mediumCategoryOther",
    };

    const i18nKey = map[key];

    return i18nKey
      ? t(`${basePath}.${i18nKey}`, { defaultValue: humanizeKey(key) })
      : humanizeKey(key);
  }

  return t(`${basePath}.${key}`, {
    defaultValue: humanizeKey(key),
  });
};

// HELPERS
// Le « type d'art » est un champ libre : on canonicalise TOUJOURS avant d'étiqueter
// (voir src/utils/artTypeTaxonomy.js). Le vide reste « — » (pas « Non renseigné »).
export const getTypeOfArtLabel = (key, t) =>
  key ? getArtkivLabel("typeOfArt", getArtTypeCanonicalKey(key), t) : getArtkivLabel("typeOfArt", key, t);

export const getAvailabilityLabel = (key, t) =>
  getArtkivLabel("availability", key, t);

export const getConditionLabel = (key, t) =>
  getArtkivLabel("condition", key, t);

export const getMediumCategoryLabelI18n = (key, t) =>
  getArtkivLabel("mediumCategory", key, t);

export const getMediumLabel = (key, t) =>
  getArtkivLabel("medium", key, t);

// Alias rétrocompatible : certains composants importent encore getTechniqueLabel.
export const getTechniqueLabel = (key, t) =>
  getMediumLabel(key, t);
